import App from 'app/app.js';

function LtConfirmDirective() {
  return {
    restrict: 'E',
    scope: {
      message: '@',
      buttonText: '@',
      bottomMessage: '@',
      close: '&'
    },
    template:
      '<div class="modal-body">' +
      '<div class="row">' +
      '<div class="col-xs-5"></div>' +
      '<div class="col-xs-2">' +
      '<lt-icon name="fa-solid-user" class="modal-glyhpicon-blue"></lt-icon>' +
      '</div>' +
      '<div class="col-xs-5"></div>' +
      '</div>' +
      '<div class="row">' +
      '<div class="col-xs-12">' +
      '<span class="modal-message" lt-translate="{{ message }}"></span>' +
      '</div>' +
      '</div>' +
      '<div class="row">' +
      '<div class="col-xs-12">' +
      '<div type="button" class="btn btn-lg btn-primary" data-ng-click="close()" lt-translate="{{ buttonText }}"></div>' +
      '</div>' +
      '</div>' +
      '<div class="row">' +
      '<div class="col-xs-12">' +
      '<span class="modal-footer-text" lt-translate="{{ bottomMessage }}"></span>' +
      '</div>' +
      '</div>' +
      '</div>'
  };
}

App.directive('ltConfirm', [LtConfirmDirective]);
